import * as React from 'react';
import { FormGroup, Input, Button } from 'reactstrap';
import { ProjectsDispatcher } from 'src/app/Container';

// import './ConfigurationCountry.page.scss';
import { connect } from 'react-redux';
import { GlobalPrivateState, countriesSelectArray, formatMessage } from 'src/api';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ConfigurationCountry.messages';
import { RequestApiResult, requestAPIActions } from 'loopback-react-request';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { Redirect } from 'react-router';
import { RouterState } from 'connected-react-router';
import { userIsInternal } from 'src/app/Partials/Admin/utils';
import { PricingsDispatcher } from 'src/app/Container/Dispatcher/PricingsDispatcher';

export interface ConfigurationCountryPageProps {
  dispatch: any;
  configuration: RequestApiResult<ConfigurationModel>;
  location: RouterState['location'];
  pricings: GlobalPrivateState['pricings'];
  user: GlobalPrivateState['user'];
}

export interface ConfigurationCountryPageState {
  redirect: boolean;
}

export class ConfigurationCountryPageComponent extends React.Component<ConfigurationCountryPageProps, ConfigurationCountryPageState > {
  constructor(props: ConfigurationCountryPageProps) {
    super(props);
    this.state = {
      redirect: false,
    };
  }

  public render() {
    const redirectUrl = this.configurationId && `/configuration/${this.configurationId}/trough`;
    const currentUrl = this.props.location.pathname;
    const isInternalUser = this.props.user && userIsInternal(this.props.user.result);
    const countries = countriesSelectArray(isInternalUser);

    // Get all markets, then find the country key, and then take the value into an array, split all the values and uppercase, then I can compare... ughhhh
    const markets = this.props.pricings && this.props.pricings.result && this.props.pricings.result.filter((p) => p.type === 'market' && !p.deleted && !p.paused);
    const marketsCountries = markets && markets.map(m => {
      const cntry = m.items.find(i => i.key === 'country');
      return cntry && cntry.value;
    }) || [];

    return (     
      <div className="page-configuration-project d-flex justify-content-center align-items-center">
        <ProjectsDispatcher />
        <PricingsDispatcher />
        <div className="container">
          <div className="row mb-5">
            <div className="col-12 col-md-8 offset-md-2">
              <h3 className="text-center mb-0">
                <FormattedMessage {...MESSAGES.configurationCountryHeadline} />
              </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-8 offset-md-2">
              <FormGroup>
                <Input
                  className="text-center"
                  type="select"
                  name="projects"
                  id="partial_project_select"
                  value={this.selectedCountry || 'none'}
                  onChange={this.handleChange}
                >
                  <option value="none">
                    {formatMessage({...MESSAGES.configurationCountrySelect})}
                  </option>
                  {countries && countries.map((country, index) => {
                    return (
                      <option key={index} value={(country.value as string).split('-')[1]}>
                        {country.label} {marketsCountries.includes(country.value) && formatMessage({...MESSAGES.configurationCountryRunning})}
                      </option>
                    )
                  })}
                </Input>
              </FormGroup>
            </div>
          </div>
          <div className="row m-0">
            <div className="col-12 text-center">
              <Button
                className="register-button mt-3"
                disabled={this.props.configuration.updating || this.selectedCountry === 'none'}
                onClick={this.handleSubmit}
                type="submit"
              >
                <FormattedMessage {...MESSAGES.configurationCountryButton} />
              </Button>
            </div>
          </div>
        </div>
        {this.state.redirect && redirectUrl && redirectUrl !== currentUrl && (
          <Redirect to={redirectUrl} />
        )}
      </div>
    );
  }

  private get configurationId(): string | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result && configuration.result.id;
  }

  handleSubmit = (e: any) => {
    // State change etc...
    // On click button continue, I think just make API request to 
    this.setState({
      redirect: true
    });
  }

  handleChange = (event: React.SyntheticEvent<HTMLInputElement>) => {
    const target = event.target as HTMLInputElement;
    const value = target.value === 'none' ? null : target.value;
    
    this.dispatchConfiguration(value);
  }

  dispatchConfiguration = (country: string | null) => {
    const { configuration } = this.props;

    this.props.dispatch(requestAPIActions.load(
      'configuration', {
        url: `/Configurations/${configuration.result && configuration.result.id}`,
        options: {
          method: 'PATCH',
          data: {
            country: country
          }
        },
      },
      true
    ));
  }

  private get selectedCountry(): string | null | undefined {
    const { configuration } = this.props;
    return configuration.result && configuration.result.country || 'none';
  }
}

export const ConfigurationCountryPage = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  location: state.router.location,
  user: state.user,
  pricings: state.pricings
}))(ConfigurationCountryPageComponent);

export default ConfigurationCountryPage;
